import gql from 'graphql-tag'

export default gql`mutation ($project_id: String){
    exportFeeDrawdownReport(project_id: $project_id)
}`